import { useContext, useEffect, useState, MouseEvent } from "react";
import { FormattedMessage } from "react-intl";
import { MenuUnstyled, MenuItemUnstyled } from '@mui/base';
import { Avatar, IconButton } from "@mui/material";
import Button from "./Button";
import { UserContext } from "../contexts/UserContext";
import { CONSTANT } from "../utils/constants";
import "../styles/HeaderNav.css";

const HeaderNav = () => {
  const { userState } = useContext(UserContext);
  const [loggedIn, setLoggedIn] = useState(false);
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const [preventReOpen, setPreventReOpen] = useState(false);
  const helpURL = `${CONSTANT.URL.HELP_CENTER}/${navigator.language.toLowerCase()}/`;
  const myaccountURL = `${CONSTANT.URL.MYACCOUNT}${navigator.language}`;

  const handleMenuClose = () => {
    setAnchorElement(null);
 };
 
  const onIconClick = (event: MouseEvent<HTMLElement>) => {
    if (preventReOpen) {
      event.preventDefault();
      setPreventReOpen(false);
      return;
    }
    anchorElement !== null ? setAnchorElement(null) : setAnchorElement(event.currentTarget);
  };

  const onIconMouseDown = () => {
    anchorElement !== null ? setPreventReOpen(true): null;
  };

  useEffect(() => {
    if(userState && Object.keys(userState).length === 0 && Object.getPrototypeOf(userState) === Object.prototype) { // check object
      setLoggedIn(false);
    } else {
      setLoggedIn(true);
    }
  }, [userState]);

  const displayUserInfo = () => {
    const { firstName, lastName } = userState;
    const displayNameArray: string[]  = [];
    firstName ? displayNameArray.push(firstName) : null;
    lastName ? displayNameArray.push(lastName) : null;
    const displayName = displayNameArray.join(" ").length > 10 ? `${displayNameArray.join(" ").substring(0, 10)}...` : displayNameArray.join(" ");
    return displayName ? (  <MenuItemUnstyled className="headernav-menuitem">
                              <a href={ myaccountURL }>{ displayName }</a>
                            </MenuItemUnstyled> )
                       : null;
  };

  const menu = (
    <MenuUnstyled
      id="headernav-menu"
      className="headernav-menu"
      open={ anchorElement !== null }
      anchorEl={ anchorElement }
      onClick={ handleMenuClose }
      onClose={ handleMenuClose }
    >
      { displayUserInfo() }
      <MenuItemUnstyled className="headernav-menuitem headernav-mobile">
        <a className="headernav-help" href={ helpURL }>
          <FormattedMessage id="help_center" />
        </a>
      </MenuItemUnstyled>
      <MenuItemUnstyled className="headernav-menuitem">
        { loggedIn ? <Button className="headernav-button" localeId="sign_out" link="/logout" color="red"/> 
                   : <Button className="headernav-button" localeId="sign_in" link="/login" color="red"/> }
      </MenuItemUnstyled>
    </MenuUnstyled>
  );

  const getNameFirstChar = () => {
    const { firstName, lastName } = userState;
    if(firstName && firstName.trim() !== "") {
      return firstName.trim()[0].toUpperCase();
    } else if (lastName && lastName.trim() !== ""){
      return lastName.trim()[0].toUpperCase();
    }
    return null;
  };

  const displayMenuIcon = () => {
    return (
      <IconButton 
        id="headernav-menuicon"
        className="headernav-icon" 
        onClick={ onIconClick }
        onMouseDown={ onIconMouseDown }
      >
        <Avatar>
          { loggedIn ? getNameFirstChar() : null }
        </Avatar>
      </IconButton>
    );
  };

  return (
    <div className="headernav">
      <a className="headernav-help headernav-desktop" href={ helpURL }>
        <FormattedMessage id="help_center" />
      </a>
      { displayMenuIcon() }
      { menu }
    </div>
  );
};

export default HeaderNav;
